interface UserAvatarProps {
  displayName?: string | null;
  username?: string;
  avatarColor?: string | null;
  size?: 'sm' | 'md' | 'lg';
}

const sizes = {
  sm: 'w-6 h-6 text-xs',
  md: 'w-8 h-8 text-sm',
  lg: 'w-10 h-10 text-base',
};

export function UserAvatar({ displayName, username, size = 'md' }: UserAvatarProps) {
  const name = displayName || username || '?';
  const initials = name
    .split(' ')
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
  // Avatar ist IMMER Coral (Marke) — bewusst nicht mehr über avatar_color definierbar.
  const bg = '#ff5a36';

  return (
    <div
      className={`${sizes[size]} rounded-full flex items-center justify-center font-semibold text-white shrink-0`}
      style={{ backgroundColor: bg }}
      title={name}
    >
      {initials}
    </div>
  );
}
